module.exports = __webpack_public_path__ + "img/outcome_01.b48d9ffb.png";